import {Banner} from '@primer/react'
import {useEffect} from 'react'
import {announce} from '@github-ui/aria-live'

import {useBatchComposition, useIsFixWithCopilotAvailable} from '../../../stores/layout-selectors'

const DISALLOWED_TAB_TITLE = 'Batch actions unavailable'
const NO_SUGGESTION_DISALLOWED_MESSAGE =
  'This batch doesn’t contain any suggestions to commit, and Fix with Copilot isn’t available on your account. You can still publish your review from the review menu.'
const MIXED_DISALLOWED_MESSAGE =
  'This batch contains items other than committable suggestions, so it can’t be committed, and Fix with Copilot isn’t available on your account. You can still publish your review from the review menu.'

export function ManageBatchDisallowedTabBanner() {
  const batchComposition = useBatchComposition()
  const isFixWithCopilotAvailable = useIsFixWithCopilotAvailable()

  const message =
    batchComposition === 'no-suggestion'
      ? NO_SUGGESTION_DISALLOWED_MESSAGE
      : batchComposition === 'mixed'
        ? MIXED_DISALLOWED_MESSAGE
        : undefined
  const shouldShowWarning = !isFixWithCopilotAvailable && message !== undefined

  useEffect(() => {
    if (shouldShowWarning && message) {
      announce(message)
    }
  }, [shouldShowWarning, message])

  if (!shouldShowWarning || !message) {
    return null
  }

  return <Banner className="mb-3" variant="warning" title={DISALLOWED_TAB_TITLE} hideTitle description={message} />
}
